<div id="rate-finder-keywords">
  <div class="titlebar-div">Comparison Keywords</div>
  <p>Keywords are used for rate identification and verification. They are compared against the Rate Access Codes, Rate
    Descriptions, and
    Room Descriptions provided by a GDS. In order to make the provided keywords as efficient as possible, all "noise"
    characters and words
    are automatically removed as they reduce the probability of a successful match.
  </p>
  <p>For additional details along with a complete list of removed words and characters please refer to the Rate
    Integrity
    Manual or Quick Start Guide.</p>
  <div id="keyword-div">
    <div id="add-keyword-div">
      <label title="">Keyword To Add
        <input id="txtKeyword" type="text" [(ngModel)]="keywordToAdd" class="upperCaseOnly input" />
      </label>
      <button id="btnAddKeyword" class="k-button cvt-primary" (click)="addKeyordClick()" [disabled]="invalidKeyword">Add
        Keyword</button>
      <br />
      <label>Original Imported Keyword List</label>
      <p class="originalKeyword">{{originalKeywordList}}</p>
    </div>
    <div class="keywordList">
      <app-configurable-link-list (deleteClickedOutput)="deleteKeyword($event)" [list]="keywordList">
      </app-configurable-link-list>
    </div>
    <select *ngIf="false" id="theSelect" size='13' class="iconFont">
      <option *ngFor="let item of keywordList " value="item">
        <a href="#">
          <span class="cvt-icon-closeDelete">&#xe934;</span>
        </a> {{item}}</option>
    </select>
  </div>
</div>
<app-modal (onOkToParent)='okCloseButtonClick(true)' (onCloseToParent)='okCloseButtonClick(false)' *ngIf='openModal'
  [dialogTitle]="dialogTitle" [dialogTextLine1]="dialogTextLine1" [dialogTextLine2]="dialogTextLine2"
  [primaryButtonText]="'OK'" [secondaryButtonText]></app-modal>
